import { useEffect, useState } from 'react';
import { marketplaceaccountApi, type MarketplaceAccount } from '../../api/marketplaceaccount';

export function ConnectionsPage() {
  const [accounts, setAccounts] = useState<MarketplaceAccount[]>([]);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState<string | null>(null);

  function load() {
    void marketplaceaccountApi.list().then(setAccounts).catch((e) => setError(String(e)));
  }

  useEffect(() => { load(); }, []);

  async function action(id: string, fn: () => Promise<unknown>) {
    setBusy(id);
    try {
      await fn();
      load();
    } catch (e) {
      setError(String(e));
    } finally {
      setBusy(null);
    }
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Marketplace Connections</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="border-b text-left">
              <th className="p-2">Code</th>
              <th className="p-2">Marketplace</th>
              <th className="p-2">Name</th>
              <th className="p-2">Status</th>
              <th className="p-2">Connection</th>
              <th className="p-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {accounts.map((a) => (
              <tr key={a.id} className="border-b">
                <td className="p-2">{a.account_code}</td>
                <td className="p-2">{a.marketplace}</td>
                <td className="p-2">{a.display_name}</td>
                <td className="p-2">{a.status}</td>
                <td className="p-2">{a.connection_status}</td>
                <td className="p-2 space-x-2">
                  <button type="button" disabled={busy === a.id} className="text-blue-600 hover:underline" onClick={() => void action(a.id, () => marketplaceaccountApi.verify(a.id))}>Verify</button>
                  <button type="button" disabled={busy === a.id} className="text-blue-600 hover:underline" onClick={() => void action(a.id, () => marketplaceaccountApi.refreshToken(a.id))}>Refresh token</button>
                  <button type="button" disabled={busy === a.id} className="text-red-600 hover:underline" onClick={() => void action(a.id, () => marketplaceaccountApi.disconnect(a.id))}>Disconnect</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {accounts.length === 0 && <p className="mt-4 text-slate-500">No marketplace accounts yet.</p>}
      </div>
    </div>
  );
}
